/**
 * Collection Showcase — size pills + ATC via theme.ProductForm / ajaxProduct:added
 * + intensity bar reveal
 */
(function () {
  function revealIntensity(root) {
    root.querySelectorAll('.vg-intensity-bar').forEach(function (bar) {
      requestAnimationFrame(function () {
        bar.classList.add('is-inview');
      });
    });
  }

  function bindAtc(form) {
    if (!form || form.dataset.vgClScBound) return;
    form.dataset.vgClScBound = '1';

    if (window.theme && theme.ProductForm) {
      try {
        new theme.ProductForm(form, '.add-to-cart', {});
        return;
      } catch (e) {
        /* fall through */
      }
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.add('btn--loading');

      var data = new FormData(form);
      var addUrl =
        (theme.routes && theme.routes.cartAdd) ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (payload) {
          if (btn) btn.classList.remove('btn--loading');
          if (payload && payload.status === 422) return;

          if (theme.settings && theme.settings.cartType === 'page') {
            window.location = theme.routes.cartPage || '/cart';
            return;
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: payload, addToCartBtn: btn },
            })
          );
        })
        .catch(function () {
          if (btn) btn.classList.remove('btn--loading');
        });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.vgClScInit) return;
    root.dataset.vgClScInit = '1';

    revealIntensity(root);
    bindAtc(root.querySelector('.vg-cl-sc__atc-form'));

    var sizeBtns = root.querySelectorAll('[data-cl-sc-size]');
    var variantInput = root.querySelector('[data-cl-sc-variant]');
    var atcBtn = root.querySelector('[data-add-to-cart]');
    var pdpLink = root.querySelector('[data-cl-sc-pdp]');

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        var variantId = btn.getAttribute('data-variant-id');
        var available = btn.getAttribute('data-available') === 'true';
        var url = btn.getAttribute('data-url');

        if (variantInput && variantId) {
          variantInput.value = variantId;
        }
        if (atcBtn) {
          if (available) atcBtn.removeAttribute('disabled');
          else atcBtn.setAttribute('disabled', 'disabled');
        }
        if (pdpLink && url) {
          pdpLink.setAttribute('href', url);
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="collection-showcase-new"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) {
      var root = evt.target.querySelector
        ? evt.target.querySelector('[data-section-type="collection-showcase-new"]') ||
          (evt.target.matches && evt.target.matches('[data-section-type="collection-showcase-new"]')
            ? evt.target
            : null)
        : null;
      if (root) {
        delete root.dataset.vgClScInit;
        initSection(root);
      }
    }
  });
})();
